import { Primitive } from '../../../../types/blocks/Primitive';

/**
 * @deprecated use PropertyInputBlock instead
 */
const GeoLocationInputBlock: Primitive = {
  name: 'GeoLocationInputBlock',
  friendlyName: 'Geolocation input',
  isInput: true,
  isPrimitive: true,
  isAvailableInEditor: true,
  tags: ['Other'],
  properties: {
    address: {
      type: 'Address',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  },
  publishes: {
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'action' is missing in type '{ type: "Eve... Remove this comment to see the full error message
    click: {
      type: 'Event',
    },
  },
};

export default GeoLocationInputBlock;
